import { render, staticRenderFns } from "./Visitor.vue?vue&type=template&id=2ca07bfa&"
import script from "./Visitor.vue?vue&type=script&lang=js&"
export * from "./Visitor.vue?vue&type=script&lang=js&"
import style0 from "./Visitor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports